module.exports = __webpack_public_path__ + "img/headersection.ec123ff1.png";